import React, { createContext, useContext } from "react";
import { appIocContainer } from "../../ioc";
import { IIoCContext } from "./IIoCContext";

const IoCContext = createContext<IIoCContext>({} as IIoCContext);

const IoCProvider: React.FC = ({ children }) => {
  return (
    <IoCContext.Provider value={{ serviceContainer: appIocContainer }}>
      {children}
    </IoCContext.Provider>
  );
};

const useIoCContext = (): IIoCContext => {
  const context = useContext(IoCContext);
  if (!Object.keys(context).length) {
    throw new Error(
      "useIoCContext deve ser utilizado dentro de um IoCProvider"
    );
  }
  return context;
};

export { useIoCContext, IoCProvider };
